import { FC } from 'react'
import { Box, Stack } from '@mui/material'
import { UploadDropzone } from '../../../Upload/subComponents'
import { OutlinedButton } from '../../../../../components/Button'

interface UploadOptionsProps {
  capturedImage: string | null,
  handleImageDrop: (acceptedFiles: File[]) => void,
  resetUpload: ()=>void,
}

export const UploadOptions:FC<UploadOptionsProps> = ({capturedImage, handleImageDrop, resetUpload}) => {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: 486,
        height: 300,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {capturedImage ? (
        <Box
          component="img"
          src={capturedImage}
          alt="Test strip"
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            borderRadius: 2,
            backgroundColor: '#f5f5f5',
          }}
        />
      ) : (
        <UploadDropzone onDrop={handleImageDrop} onBrowseClick={() => {}} />
      )}
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={2}
        justifyContent="center"
        mt={3}
      >
        <OutlinedButton
          fullWidth
          size="large"
          onClick={resetUpload}
          sx={{
            py: 1.5,
            px: 4,
            backgroundColor: 'white',
            border: '1px solid #D0D5DD',
            color: 'primary.dark',
          }}
        >
          Retake Picture
        </OutlinedButton>
      </Stack>
    </Box>
  )
}